<script>
  export var settings;

  import {
    Button,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Card,
    Col,
  } from "sveltestrap";
  import { Form, FormGroup, FormText, Label } from "sveltestrap";
  import Upgrade from './Upgrade.svelte';
</script> 

Integrations provide action to allow you to automate processes.
<Upgrade />
Current:
{#if settings.teams.length == 0}
  None
{:else}
  {#each settings.integrations as integ}
    <Card body>
      Type:
      {integ.type}
      <FormGroup>
        <Label for="exampleEmail">Email</Label>
        <Input type="email" name="email"
          placeholder="with a placeholder"  bind:value={integ.email} />
      </FormGroup>
      <br />Trigger:

      <FormGroup check>
        <Label check>
          <Input type="checkbox" value="run_success" bind:checked={integ.run_success} />
          Run success
        </Label>
      </FormGroup>
      <FormGroup check>
        <Label check>
          <Input type="checkbox" value="run_failure" bind:checked={integ.run_failure}  />
          Run failure
        </Label>
      </FormGroup>
      <FormGroup check>
        <Label check>
          <Input type="checkbox" value="per_break"  bind:checked={integ.per_break} />
          Per break
        </Label>
      </FormGroup>
    </Card>
  {/each}
{/if}
